export default __webpack_public_path__ + "static/meltydip-6804bdc3fbae8797c56a674f03f12eff.png";